import React from "react";
import { motion } from "framer-motion";

const LOGO_BASE = "/assets/practicelogos";

// Curated, clean customer logos that read well on white tiles.
const logos = [
  { src: `${LOGO_BASE}/lumendental.webp`, alt: "Lumen Dental" },
  { src: `${LOGO_BASE}/harborhilldentistry.webp`, alt: "Harbor Hill Dentistry" },
  { src: `${LOGO_BASE}/eastwindsordentalarts.webp`, alt: "East Windsor Dental Arts" },
  { src: `${LOGO_BASE}/image 5.png`, alt: "Alpha Dental Excellence" },
  { src: `${LOGO_BASE}/dental360group.png`, alt: "Dental 360 Group" },
  { src: `${LOGO_BASE}/clovis.png`, alt: "Clovis Family Dentistry" },
  { src: `${LOGO_BASE}/image 1.png`, alt: "ProCare Dentistry" },
  { src: `${LOGO_BASE}/funtasticdental.webp`, alt: "FUNtastic Pediatric Dental" },
  { src: `${LOGO_BASE}/advanceddentalhealth.png`, alt: "Advanced Dental Health" },
  { src: `${LOGO_BASE}/image 3.png`, alt: "Marquette Dentistry" },
  { src: `${LOGO_BASE}/aristodental.webp`, alt: "Aristo Dental" },
  { src: `${LOGO_BASE}/villalagodentistry.jpeg`, alt: "Villa Lagos Dentistry" },
  { src: `${LOGO_BASE}/image 4.png`, alt: "Fabulous Smiles of Atlanta" },
  { src: `${LOGO_BASE}/premier.png`, alt: "Premier Dentistry" },
  { src: `${LOGO_BASE}/nextgenerationdentistry.avif`, alt: "Next Generation Dentistry" },
];

const third = Math.ceil(logos.length / 3);
const rowA = logos.slice(0, third);
const rowB = logos.slice(third, third * 2);
const rowC = logos.slice(third * 2);

const LogoTile = ({ logo }) => (
  <div className="flex-shrink-0 h-[96px] w-[220px] rounded-xl bg-white border border-slate-200 shadow-[0_6px_18px_-10px_rgba(15,23,42,0.18)] flex items-center justify-center px-7 overflow-hidden">
    <img
      src={logo.src}
      alt={logo.alt}
      className="max-h-[56px] max-w-[164px] w-auto object-contain"
    />
  </div>
);

const Marquee = ({ items, reverse = false, duration = 38 }) => (
  <div className="flex gap-5 w-max" style={{ willChange: "transform" }}>
    <motion.div
      className="flex gap-5 w-max"
      animate={{ x: reverse ? ["-50%", "0%"] : ["0%", "-50%"] }}
      transition={{ repeat: Infinity, ease: "linear", duration }}
    >
      {[...items, ...items].map((logo, i) => (
        <LogoTile key={i} logo={logo} />
      ))}
    </motion.div>
  </div>
);

const PracticesWeServeSlide = () => {
  return (
    <div className="h-full w-full bg-slate-50 flex flex-col p-6 xl:p-8 relative overflow-hidden font-sans">
      {/* Background blobs */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-blue-100/40 rounded-full blur-[120px] -translate-y-1/3 translate-x-1/4" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-fuchsia-100/40 rounded-full blur-[100px] translate-y-1/3 -translate-x-1/4" />
      <div className="absolute inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:32px_32px] opacity-40" />

      <div className="max-w-[1280px] w-full mx-auto flex flex-col h-full relative z-10 justify-center">
        {/* Title */}
        <div className="text-center mb-10 flex-shrink-0">
          <motion.h2
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl lg:text-[2.9rem] font-extrabold text-slate-900 tracking-tight leading-[1.12] max-w-[1000px] mx-auto"
          >
            Trusted by{" "}
            <span className="bg-gradient-to-r from-blue-600 via-violet-600 to-fuchsia-600 bg-clip-text text-transparent">
              solo offices, groups, and DSOs
            </span>
            .
          </motion.h2>
        </div>

        {/* Logo wall — three animated rows */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.25 }}
          className="relative space-y-6"
        >
          {/* edge fades */}
          <div className="absolute left-0 top-0 bottom-0 w-28 z-10 bg-gradient-to-r from-slate-50 to-transparent pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-28 z-10 bg-gradient-to-l from-slate-50 to-transparent pointer-events-none" />

          <div className="overflow-hidden">
            <Marquee items={rowA} duration={42} />
          </div>
          <div className="overflow-hidden">
            <Marquee items={rowB} reverse duration={48} />
          </div>
          <div className="overflow-hidden">
            <Marquee items={rowC} duration={44} />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PracticesWeServeSlide;
